import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Skills Redux States
import {
  SEND_STATUS
} from "./actionTypes";
import {
  sendStatusSuccess
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";


function* sendStatus({ payload: { data } }) {

  try {
    let aux = { status: data.status };

    const url = `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/sendStatus/${data.chatId}`;

    const response = yield call(
      axios.post, url, aux
    )

    if (response.status === 200) {
      yield put(sendStatusSuccess(response.data));
    } else {
      throw response.data;
    }
  } catch (error) {
    console.log("API ERROR ON SENDSTATUS : ", error);
  }
}

export function* watchStatus() {
  yield takeEvery(SEND_STATUS, sendStatus);
}

function* authSaga() {
  yield all([
    fork(watchStatus),
  ]);
}


export default authSaga;